export default "__VITE_ASSET__CbIb$W7s__"